import { Space } from 'antd';
import styled from 'styled-components';

export const ResendCodeWrapper = styled(Space)`
  width: 100%;
  justify-content: center;
  margin-bottom: 12px;
`;
